"use client";

import { useEffect } from "react";

import {
  isExpectedBoundaryError,
  useReportBoundaryError,
} from "@/shared/lib/use-report-boundary-error";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useReportBoundaryError(error, "global-error");

  useEffect(() => {
    if (isExpectedBoundaryError(error)) {
      setTimeout(() => {
        if (typeof window !== "undefined") {
          window.location.reload();
        }
      }, 1000);
    }
  }, [error]);

  if (isExpectedBoundaryError(error)) {
    return (
      <div className="flex h-screen flex-col items-center justify-center gap-4 p-4 text-center">
        <div className="space-y-2">
          <h1 className="text-2xl font-bold">Загрузка...</h1>
          <p className="text-muted-foreground">
            Обновление страницы...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-4 p-4 text-center">
      <div className="space-y-2">
        <h1 className="text-4xl font-bold">Что-то пошло не так!</h1>
        <p className="text-muted-foreground">
          Произошла неожиданная ошибка. Попробуйте обновить страницу.
        </p>
        {process.env.NODE_ENV === "development" && error?.message && (
          <p className="text-sm text-destructive mt-4 max-w-md">
            {error.message}
          </p>
        )}
        {error?.digest && (
          <p className="text-xs text-muted-foreground">ID: {error.digest}</p>
        )}
      </div>
      <button
        onClick={reset}
        className="rounded bg-primary px-4 py-2 text-primary-foreground hover:bg-primary/90"
      >
        Попробовать снова
      </button>
    </div>
  );
}
